import $ from 'jquery'
import Cookies from 'js-cookie'

const SELECTORS = {
    announcement: '[data-announcement]',
    closeBtn: '[data-announcement-close]'
}

const CLASSES = {
    invisible: 'announcement--invisible'
}

const COOKIE_NAME = 'dismissed_announcements'

class Announcement {
    constructor() {
        this.$element = $(SELECTORS.announcement)

        if (!this.$element) {
            return
        }

        this.id = this.$element.data('announcement-id')
        this.$closeBtn = $(SELECTORS.closeBtn, this.$element)
        this.dismissedAnnouncements = []

        this.init()
    }

    init() {
        if (this.wasDismissed()) {
            this.$element.remove()
        } else {
            this.show()
            this.$closeBtn.click(() => this.dismiss())
        }
    }

    show() {
        this.$element.removeClass(CLASSES.invisible)
        this.$element.removeAttr('aria-hidden')
    }

    hide() {
        this.$element.slideUp(300)
    }

    wasDismissed() {
        const cookie = Cookies.get(COOKIE_NAME)
        if (cookie) {
            this.dismissedAnnouncements = JSON.parse(cookie)
            return this.dismissedAnnouncements.includes(this.id)
        }
        return false
    }

    dismiss() {
        this.dismissedAnnouncements.push(this.id)
        Cookies.set(COOKIE_NAME, this.dismissedAnnouncements)
        this.hide()
    }
}

$(document).ready(() => new Announcement())
